var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('caregiver-form',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"caregiver":_vm.caregiver},on:{"submit":_vm.createCaregiver,"cancel":_vm.cancelCreateCaregiver}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }